import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay]);



function handleThumbClick(thumb) {
   
    const parent = thumb.closest('.car-item');
    const link = parent.querySelector('a').getAttribute('href');
    window.location.href = link;
}



export function changeCarsImages() {
const carContainers = document.querySelectorAll('.car-item');
    if (carContainers) {
    carContainers.forEach(container => {
        const mainImage = container.querySelector('.car-item img');
        const thumbnails = container.querySelectorAll('.nav-items li');
        
        thumbnails.forEach(thumb => {
            thumb.addEventListener('mouseenter', function() {
                const newSrc = this.getAttribute('data-src');
                
                // Удаляем active класс у всех миниатюр в этом контейнере
                thumbnails.forEach(t => t.classList.remove('active'));
                // Добавляем текущему
                this.classList.add('active');
                
                // Плавная смена
                // mainImage.style.opacity = '0';
                // setTimeout(() => {
                //     mainImage.src = newSrc;
                //     mainImage.style.opacity = '1';
                // }, 150);
                 mainImage.src = newSrc;
            });
            // thumb.addEventListener('click', handleThumbClick(thumb));
            // thumb.addEventListener('touchstart', handleThumbClick(thumb), { passive: false });

            thumb.addEventListener('click',()=> {
                const parent = thumb.closest('.car-item');
                const link = parent.querySelector('a').getAttribute('href');
                window.location.href = link;
     
            });

        });
    });
 }
}






export function initFavorites() {
    const favoriteButtons = document.querySelectorAll('.favorite');
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    
    // Инициализируем состояние кнопок
    favoriteButtons.forEach(button => {
        const id = button.dataset.id;
        if (favorites.includes(id)) {
            button.classList.add('active');
            button.title = 'Удалить из избранного';
        }
    });
    
    // Обновляем счетчик избранного
    updateFavoritesCount(favorites); // ✅ Вызываем один раз с аргументом
    
    // Обработчик клика для всех кнопок
    favoriteButtons.forEach(button => {
        button.addEventListener('click', function() {
            const id = this.dataset.id;
            const index = favorites.indexOf(id);
            
            if (index === -1) {
                favorites.push(id);
                this.classList.add('active');
                this.title = 'Удалить из избранного';
            } else {
                favorites.splice(index, 1);
                this.classList.remove('active');
                this.title = 'Добавить в избранное';
            }
            
            localStorage.setItem('favorites', JSON.stringify(favorites));
            updateFavoritesCount(favorites); // ✅ Вызываем с аргументом
        });
    });
}

// Обычная функция (не экспортируется)
function updateFavoritesCount(favorites) {
       
    // Защита от ошибок
    if (!Array.isArray(favorites)) {
        favorites = [];
    }
    
    const countElement = document.querySelector('.countf');
    
    if (countElement) {
        const count = favorites.length;
        countElement.textContent = count > 0 ? count : '0';
    }
}




// Фабрика троттлинга с правильным поведением
export function createThrottle(fn, delay) {
  let canExecute = true;
  let lastExecution = 0;
  
  return async function(...args) {
    const now = Date.now();
    const timeSinceLast = now - lastExecution;
    
    // Если прошло меньше времени, чем задержка — НИЧЕГО НЕ ДЕЛАЕМ
    if (timeSinceLast < delay) {
      return null; // Возвращаем null, чтобы вызывающий код знал, что функция не выполнилась
    }
    
    // Обновляем время последнего выполнения
    lastExecution = now;
    
    // Выполняем функцию
    return await fn(...args);
  };
}

export const throttledCarListForm = createThrottle(
  () => getStaticForm('/api/car-list-reserve'),
  200
);

export function initCarListModals() {
  const carListButton = document.querySelectorAll('.car-item .greenbut');
  
  carListButton.forEach((ctx) => {
    ctx.addEventListener('click', async () => {
      const parent = ctx.closest('.car-item');
      const title = parent.querySelector('.name').textContent;
      const image = parent.querySelector('img');

      // Ждём результат троттлинга
      const result = await throttledCarListForm();
      
      // Если result === null, значит троттлинг сработал — выходим
      if (result === null) {
        console.log('Троттлинг: запрос проигнорирован');
        return;
      }
      

      
      const formTitle = document.querySelector('.ajax .title');
      const imageBox = document.querySelector('.ajax img');

      imageBox.src = image.src;
      formTitle.textContent = title;
    });
  });
}




async function getStaticForm(url){
        const container = document.querySelector('.ajax');
            const loader = document.querySelector('.loader-icon');
      if (loader) loader.style.display = 'flex';
   try {

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            // body: JSON.stringify(requestData) // Используем requestData здесь
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        
        const data = await response.json();
        if (loader) loader.style.display = 'none';
        container.innerHTML = data.html;
      
    } catch (error) {
        console.error('Error loading cars:', error);

    } finally {
        initForm();
        initMask();
      const bg = document.querySelector('.bg');
      const close = document.querySelector('.close');
      bg.addEventListener('click',()=>{
        container.innerHTML = '';
      });
      close.addEventListener('click',()=>{
        container.innerHTML = '';
      });
      
    }
}

function initForm() {
  const forms = document.querySelectorAll('.sendform');
if (forms) {
  forms.forEach(form => {
    form.addEventListener("submit", handleFormSubmit);
  });
}
}
export function initStaticForm() {
        initForm();
        initMask();
}



async function handleFormSubmit(e) {

  e.preventDefault();
  
  const form = e.target;
  const phoneInput = form.querySelector('input[name="phone"]');

  const submitButton  = form.querySelector('button');
  const checkbox = form.querySelector('input[name="politic"]');
  const checkMark = form.querySelector('.checkmark-check');

  const phone = phoneInput.value;




  phoneInput.style.border = '1px solid #e8e8e8';

  if (!validatePhone(phone)) {
    if (phoneInput.errorTimeout) {
      clearTimeout(phoneInput.errorTimeout);
    }
   
  phoneInput.errorTimeout = setTimeout(() => {
      phoneInput.style.border = '1px solid red';
    }, 300);
    return false;
  }


if (!checkbox.checked) {
  checkMark.classList.add('highlight-animation')
  checkMark.style.border = '1px solid red';

  setTimeout(()=> {
 checkMark.classList.remove('highlight-animation')
  },1000);

     return false;
}


    submitButton.disabled = true;
    submitButton.innerHTML = 'Отправка';

  const type = form.getAttribute('data-type') || '';
  const formData = new FormData(form);
  formData.append('type', type);

  try {
    // Создаем массив промисов
    const promises = [
      fetch("/sendform", {
        method: "POST",
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        }
      })
    ];

    // Добавляем Comagic только если он доступен
    if (isComagicAvailable()) {
      promises.push(sendToComagic(formData, form));
    }

    const [serverResponse, comagicResponse] = await Promise.all(promises);
    
    if (!serverResponse.ok) throw new Error("Ошибка сервера");
    
    const result = await serverResponse.json();
    form.reset();
    
    // Учитываем что comagicResponse может быть undefined
    const successMessage = comagicResponse === false 
      ? 'Заявка принята, но возникла проблема с системой уведомлений. Мы вам перезвоним.'
      : 'Спасибо! Заявка отправлена. В ближайшее время с Вами свяжется менеджер.';
    
    showMessage(successMessage);
if (typeof ym !== 'undefined') {
  // ym(96709111,'reachGoal','form_send')
}


  } catch (error) {
    console.error("Ошибка:", error);
    showMessage('Ошибка отправки формы! Пожалуйста, попробуйте позже.');
  } finally {
    // В любом случае разблокируем кнопку и убираем прелоадер
    submitButton.disabled = false;
    submitButton.textContent = 'Отправить';
    const ajaxContainer = document.querySelector('.ajax');
    ajaxContainer.innerHTML = '';
  }
}


async function sendToComagic(formData, formElement) {
  if (!isComagicAvailable()) {
    console.log('Comagic не доступен, пропускаем отправку');
    return true; // Возвращаем true, чтобы не прерывать основной поток
  }

  const comagicData = {
    phone: formData.get('phone'),
    name: formData.get('name') || '',
    form_name: formElement.getAttribute('data-type') || 'Форма с сайта',
    message: Array.from(formData.entries())
      .filter(([key]) => !['phone', 'name', '_token'].includes(key))
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n')
  };

  return new Promise((resolve) => {
    window.Comagic.addOfflineRequest(comagicData, function(o) {
      if (o instanceof XMLHttpRequest) {
        o = JSON.parse(o.response);
      }
      resolve(o.success);
    });
  });
}


function initMask() {
   import('imask').then(({ default: IMask }) => {
const elements = document.querySelectorAll('input[name="phone"]');

if (elements.length) {

const maskOptions = {
  mask: '+{7} (#00) 000-00-00',
  placeholderChar: '_',
 lazy: false,
 definitions: {
    '#': /[49]/
  },
 
};
let mask = '';
for (let i = 0; i < elements.length; i++) {
  // Инициализация маски для элемента
  const mask = IMask(elements[i], maskOptions);
  
  // Добавление слушателя события focus
  elements[i].addEventListener('focus', function() {

    // Дополнительные действия при фокусе
    // Например, можно выделить поле ввода:
//  mask.updateCursor(7);

  });
}
// const mask = IMask(element, maskOptions);
}
});
}

function validatePhone(phone) {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length === 11 && (cleaned[0] === '7' || cleaned[0] === '8');
}


function throttle(func, limit = 100) {
  let inThrottle;
  return function() {
    if (!inThrottle) {
      func.apply(this, arguments);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}



export function initCallBackForm() {
const callbacks = document.querySelectorAll('.callback');

const throttledCallback = throttle(() => getStaticForm('/api/callback'), 100);
callbacks.forEach(ctx=>{
ctx.addEventListener('click',throttledCallback);
});
}

export function initAjaxCreditForm() {
const creditBut = document.querySelector('.credit__plate-button');

const throttledCredit = throttle(() => {getStaticForm('/api/credit-form').then(()=>{
  const title = document.querySelector('.car-card.active .car-card-title').textContent;    
  const price = document.querySelector('.car-card.active .car-card-price').innerHTML;
  const parent = document.querySelector('.ajax');
  const textDiv = parent.querySelector('.text');
textDiv.innerHTML = title+price;
  // console.log(textDiv);

})}, 100);
creditBut.addEventListener('click', ()=>{
throttledCredit()


} );


}






function isComagicAvailable() {
  return typeof window.Comagic !== 'undefined' && 
         typeof window.Comagic.addOfflineRequest === 'function';
}

function showMessage(message, type = 'success') {
  // Создаем элементы
  const messageContainer = document.createElement('div');
  const messageTitle = document.createElement('div');
  const messageBg = document.createElement('div');
  
  // Добавляем классы
  messageContainer.className = `show__message show__message--${type}`;
  messageTitle.className = 'show__message-title';
  messageBg.className = 'show__message-bg';
  
  // Устанавливаем текст
  messageTitle.textContent = message;
  
  // Собираем структуру
  messageContainer.appendChild(messageTitle);
  
  // Добавляем в body
  document.body.appendChild(messageContainer);
  document.body.appendChild(messageBg);
  
  // Автоматическое закрытие через 5 секунд
//   setTimeout(() => {
//     messageContainer.remove();
//     messageBg.remove();
//   }, 5000);
   // Закрытие по клику на фон
  messageBg.addEventListener('click', () => {
    messageContainer.remove();
    messageBg.remove();
  });
}




export function initCarSinglePageModal() {
    
const butReserve = document.querySelector('.rezerv');
if (butReserve) {
    butReserve.addEventListener('click', async ()=>{
    await  throttledSingleCarForm();
      const name = document.querySelector('.car-form-name').textContent;
      const image = document.querySelector('.car-form-image img');

           const formTitle = document.querySelector('.ajax .title');
     const imageBox = document.querySelector('.ajax img');

    imageBox.src = image.src;

     formTitle.textContent = name;

    });
}
}

async function throttledSingleCarForm() {

  let canFetch;
  // if (!canFetch) return;
  canFetch = false;
  try {

    await getStaticForm('/api/single-car-reserve');
  } finally {
    setTimeout(() => {
      canFetch = true;
    }, 100);
  }
}



export function formatPrice(price) {
    return Number(price).toLocaleString('ru-RU', {
        maximumFractionDigits: 0,
        useGrouping: true
    }).replace(/,/g, ' ');
}


export function returnOnlyNumbers(string) {
    const clearString = String(string).replace(/\D/g, '');
    const numeric = parseInt(clearString) || 0;
    return numeric;
}



function toggleMenu() {
const menuCommon = document.querySelector('.menu-items');
const openTopMenu = document.querySelector('.top-menu');
openTopMenu.classList.toggle('active');
menuCommon.classList.toggle('active');
  document.body.classList.toggle('no-scroll');


}

export function initMenu() {
    const menuCommon = document.querySelector('.menu-items');
const openTopMenu = document.querySelector('.top-menu');
openTopMenu.addEventListener('click',function(e){
   e.stopPropagation();
toggleMenu();
});
document.addEventListener('click', function(e) {
    const target = e.target; // Кликнутый элемент

    // Проверяем, был ли клик по меню или по кнопке меню
    const isClickInsideMenu = target === menuCommon || menuCommon.contains(target); // Проверяем, находится ли элемент внутри меню
    const isClickOnMenuButton = target === openTopMenu; // Проверяем, кликнули ли по самой кнопке

    // Если меню открыто и клик был НЕ внутри меню и НЕ по кнопке
    if (menuCommon.classList.contains('active') && !isClickInsideMenu && !isClickOnMenuButton) {
        toggleMenu(); // Закрываем меню
    }
});

const showBrand = document.querySelector('.show-catalog');
const brands = document.querySelector('.menu-items .brands');
if (window.innerWidth > 768) {
  

showBrand.addEventListener('mouseenter', function() {
    brands.classList.add('active')
});
}
brands.addEventListener('mouseleave', function() {
    brands.classList.remove('active')
});
}


export function loadFavoritesFromLocalStorage() {
    // Получаем избранное из localStorage
    const favorites = JSON.parse(localStorage.getItem('favorites')) || [];

    if (favorites.length === 0) {
        // Если избранное пустое
        document.querySelector('.favorites-inner').innerHTML = `
            <div class="alert alert-info">
                В избранном пока нет автомобилей
            </div>
        `;
        return;
    }
    
    // Отправляем запрос на сервер для получения данных
    fetch('/api/favorites/get', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
             },
        body: JSON.stringify({ ids: favorites })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            // Отображаем автомобили
            // document.getElementById('cars-list').innerHTML = data.html;
     document.querySelector('.favorites-inner').innerHTML = '';
  
document.querySelector('.favorites-inner').innerHTML = data.html;

          initFavorites();
          changeCarsImages();
          initCarListModals();
        } else {
            showErrorMessage();
        }
       })
    .catch(error => {
        console.error('Error:', error);
        showErrorMessage();
    });
}


/**
 * Инициализирует скрытие/показ хедера при прокрутке
 * @param {Object} options - Опции
 * @param {string} options.headerSelector - Селектор хедера (по умолчанию 'header')
 * @param {number} options.threshold - Порог скролла для срабатывания (по умолчанию 100)
 * @param {number} options.scrollDelay - Задержка между срабатываниями в мс (по умолчанию 100)
 */
export function initStickyHeader({
  headerSelector = 'header',
  threshold = 100,
  scrollDelay = 100
} = {}) {
  const header = document.querySelector(headerSelector);
  
  // Защита от отсутствия хедера на странице
  if (!header) return;

  let lastScrollY = window.scrollY;
  let ticking = false;
  const headerHeight = header.offsetHeight;
  // Компенсируем прыжок контента
  document.body.style.paddingTop = `${headerHeight}px`;
  
  // Основная логика обновления хедера
  function updateHeader() {
    const currentScrollY = window.scrollY;
    
    if (currentScrollY > lastScrollY && currentScrollY > threshold) {
      // Прокрутка вниз - скрываем
      header.classList.add('hiddenHeader');
      header.classList.remove('visible');
    } else if (currentScrollY < lastScrollY) {
      // Прокрутка вверх - показываем
      header.classList.remove('hiddenHeader');
      header.classList.add('visible');
    }
    
    // Всегда показываем на самом верху
    if (currentScrollY < 100) {
      header.classList.remove('hiddenHeader', 'visible');
    }
    
    lastScrollY = currentScrollY;
  }

  // Троттлинг обработчика скролла
  const throttledScroll = throttle(() => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
      
      setTimeout(() => {
        ticking = false;
      }, scrollDelay);
    }
  }, scrollDelay);

  // Подписка на событие скролла
  window.addEventListener('scroll', throttledScroll, { passive: true });

  // Возвращаем функцию для очистки (опционально)
  return () => {
    window.removeEventListener('scroll', throttledScroll);
    document.body.style.paddingTop = '';
    header.classList.remove('hidden', 'visible');
  };
}

export function initFixedMenu({
  containerSelector = '.container',
  menuSelector = '.menu-items',
  // headerSelector = 'header',
  updateOnResize = true,
  updateOnScroll = false
} = {}) {
  const container = document.querySelector(containerSelector);
  const menu = document.querySelector(menuSelector);
  // const header = document.querySelector(headerSelector);
  if (!container || !menu) return;
  
  function updatePosition() {
    // const rectHeader = header.getBoundingClientRect();
    const rect = container.getBoundingClientRect();
    menu.style.left = `${rect.left + 15}px`;
    menu.style.width = `${rect.width}px`;
    // menu.style.top = `${rectHeader.height}px`;
  }
  
  // Инициализация
  updatePosition();
  
  // Подписка на события
  const events = [];
  
  if (updateOnResize) {
    const resizeHandler = () => updatePosition();
    window.addEventListener('resize', resizeHandler);
    events.push({ type: 'resize', handler: resizeHandler });
  }
  
  if (updateOnScroll) {
    const scrollHandler = () => updatePosition();
    window.addEventListener('scroll', scrollHandler, { passive: true });
    events.push({ type: 'scroll', handler: scrollHandler });
  }
  
  // Функция очистки
  return () => {
    events.forEach(({ type, handler }) => {
      window.removeEventListener(type, handler);
    });
  };
}


export function toTop() {
  const toTopButton = document.querySelector('.to-top');
  toTopButton.addEventListener('click',()=>{
    window.scrollTo({
  top: 0,
  behavior: 'smooth'
});
  });
  
}




export function initEnterSubmit(){

const filterForm = document.getElementById('filter');
  filterForm.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && ['priceto', 'mileageto'].includes(e.target.name)) {
      e.preventDefault();
      document.querySelector('.show-cars')?.click();
    }
  });
}

export function initToggleCatalog({
  buttonSelector = '.show__all-b',
  catalogSelector = '.top-alphabet',
  textShow = 'Показать все',
  textHide = 'Скрыть'
} = {}) {
  const button = document.querySelector(buttonSelector);
  const catalog = document.querySelector(catalogSelector);
  
  if (!button || !catalog) return;
  
  // Сохраняем обработчик для возможности удаления
  function handleClick() {
    const isActive = catalog.classList.toggle('active');
    button.textContent = isActive ? textHide : textShow;
  }
  
  button.addEventListener('click', handleClick);
  
  // Инициализация текста кнопки
  button.textContent = catalog.classList.contains('active') 
    ? textHide 
    : textShow;
  
  return () => {
    button.removeEventListener('click', handleClick);
  };
}



export function initAccordeon() {

const accordeonContainer = document.querySelector('.accordeon');
if (accordeonContainer) {
 const questions = accordeonContainer.querySelectorAll('.question');
 questions.forEach(function(ctx){
      ctx.addEventListener('click',()=>{
      const parent = ctx.closest('.item');
      parent.classList.toggle('active');
      })
 }); 
}
}

export class ResponsiveManager {
    constructor(breakpoint = 768, callbacks = {}) {
        this.breakpoint = breakpoint;
        this.callbacks = callbacks;
        this.isMobile = window.innerWidth < this.breakpoint;
        this.resizeTimer = null;

        this.init();
        // Вызываем колбэки для начального состояния
        this.triggerInitialCallbacks();
     
    }
    
    init() {
        window.addEventListener('resize', this.handleResize.bind(this));
        
    }
    
    triggerInitialCallbacks() {
        // Вызываем соответствующий колбэк при инициализации
    
        if (this.isMobile && this.callbacks.onMobile) {
            this.callbacks.onMobile();
             
        } else if (!this.isMobile && this.callbacks.onDesktop) {
            this.callbacks.onDesktop();
            
        }
    }
    
    checkWindowSize = () => {
        const currentIsMobile = window.innerWidth < this.breakpoint;
        
        if (currentIsMobile !== this.isMobile) {
            this.isMobile = currentIsMobile;
            
            if (this.isMobile) {
                // console.log('Переключились на мобильную версию');
                if (this.callbacks.onMobile) this.callbacks.onMobile();
            } else {
                // console.log('Переключились на десктопную версию');
                if (this.callbacks.onDesktop) this.callbacks.onDesktop();
            }
        }
    }
    
    handleResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.checkWindowSize, 250);
    }
    
    destroy() {
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimer);
    }
    
    getIsMobile() {
        return this.isMobile;
    }
}


export function initCarsListSwiper() {
    const carsList = document.querySelectorAll('.swiper-all');
    
    if (carsList.length === 0) return null;
    
    const swipers = [];
    
    carsList.forEach((ctx,ind) => {
        // Проверяем, не инициализирован ли уже Swiper
        if (ctx.swiper) {
            swipers.push(ctx.swiper);
            return;
        }
        
        const swiper = new Swiper(ctx, {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            slidesPerView: 1,
            speed: 400,
            pagination: {
                el: '.swiper-pagination'+ind,
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next'+ind,
                prevEl: '.swiper-button-prev'+ind,
            },
        });
        
        swipers.push(swiper);
    });
    
    // Возвращаем объект с методами
    return {
        instances: swipers,
        destroy() {
            swipers.forEach(swiper => {
                if (swiper && typeof swiper.destroy === 'function') {
                    swiper.destroy(true, true);
                }
            });
            swipers.length = 0;
        },
        isDestroyed: false
    };
}

function copyTextToClipboard(text) {
  // Пробуем современный метод
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text)
      .then(() => console.log('Текст скопирован!'))
      .catch(err => {
        console.error('Ошибка: ', err);
        fallbackCopy(text);
      });
  } else {
    // Используем старый метод
    fallbackCopy(text);
  }
}

function fallbackCopy(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  console.log('Текст скопирован (старый метод)!');
}

export function copyEmailToBuffer() {
  const email = 'info@carzona.ru';
  const copyBut = document.querySelector('.copy-mail');
  const showMessage = document.createElement('div');
  showMessage.textContent = 'Скопировано';
 
  
  if (copyBut) {
    copyBut.addEventListener('click', (e) => {
      e.preventDefault();
      copyTextToClipboard(email);
       copyBut.appendChild(showMessage);
       setTimeout(()=>{
          copyBut.removeChild(showMessage);
       },1000)
    });
  }
}


export function copyLotNumberToBuffer() {
    const but = document.querySelector('.number-lot');
    const id = but.dataset.id;
  const showMessage = document.createElement('div');
  showMessage.textContent = 'Скопировано';
     but.addEventListener('click', (e) => {
      e.preventDefault();
      console.log(id)
      copyTextToClipboard(id);
       but.appendChild(showMessage);
       setTimeout(()=>{
          but.removeChild(showMessage);
       },1000)
    });
}




export function setCoockie() {
  const COOKIE_KEY = 'cookie_accepted';
    
    if (!localStorage.getItem(COOKIE_KEY)) {
        // Создаем уведомление
        const notification = document.createElement('div');
        notification.style.cssText = `
            position: fixed;
            bottom: 20px;
            right: 20px;
            background: #fff;
            padding: 15px 20px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            z-index: 9999;
             max-width: 400px;
            display: flex;
            gap: 15px;
            align-items: center;
            flex-wrap: wrap;
        `;
        
        notification.innerHTML = `
            <span style="font-size: 14px; color: #333;">
                🍪 Этот сайт использует cookie
            </span>
            <button id="acceptCookie" style="
                background: #13A582;
                color: white;
                border: none;
                padding: 5px 15px;
                border-radius: 4px;
                cursor: pointer;
            ">Принять</button>
        `;
        
        document.body.appendChild(notification);
        
        document.getElementById('acceptCookie').onclick = () => {
            localStorage.setItem(COOKIE_KEY, 'true');
            notification.remove();
        };
    }


}
